import { render, staticRenderFns } from "./ManageCerts.vue?vue&type=template&id=79e54d34&scoped=true&"
import script from "./ManageCerts.vue?vue&type=script&lang=js&"
export * from "./ManageCerts.vue?vue&type=script&lang=js&"
import style0 from "./ManageCerts.vue?vue&type=style&index=0&id=79e54d34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e54d34",
  null
  
)

export default component.exports